<div class="page-layout load-content">
    <app-progress-bar (reload)="loadDeal()"></app-progress-bar>
    <div
        class="container-fluid h-100"
        *ngIf="dealInfo"
    >
        <div class="row">
            <div class="col-12 d-flex justify-content-end">
                <!-- <onwac-dropdown 
                (onChange)="changeCompany($event.key, true)" 
                [list]="companiesSelect"
                [selected_index]="0"></onwac-dropdown> -->
                <div class="actions-bar mb-sm">
                    <onwac-button
                        [text]="'FUNNEL.refresh' | translate"
                        [type]="'icon'"
                        [icon]="'autorenew'"
                        (click)="loadDeal()"
                    ></onwac-button>
                </div>
            </div>
        </div>
        <div class="row h-100 deal-page">
            <div class="col-12 col-lg-2">
                <div class="info-section">
                    <div class="info-title">{{ 'FUNNEL.dealPage.scoring' | translate }}</div>
                    <div class="info-response d-flex align-items-center">
                        <div class="chip scoring"> {{dealInfo.step_history.deal.scoring}}</div>
                    </div>
                </div>
                <div class="info-section">
                    <div class="info-title">{{ 'FUNNEL.dealPage.status' | translate }}</div>
                    <div class="chip">{{dealInfo.step_history.step_name}}</div>
                </div>
                <div class="info-section">
                    <div class="info-title">{{ 'FUNNEL.dealPage.lastUpdate' | translate }}</div>
                    <div class="info-response">{{dealInfo.step_history.updated_at | date:'d/M/yy'}}</div>
                </div>
                <!-- ANALYST -->
                <div
                    class="info-section"
                    *ngIf="dealInfo.step_history.deal.coordinator_data"
                >
                    <div class="info-title">{{ 'FUNNEL.dealPage.analyst' | translate }}</div>
                    <div class="user-info">
                        <div
                            class="avatar"
                            [style.background]="'url(' + dealInfo.step_history.deal.coordinator_data.avatar + ')'"
                        >
                        </div>
                        <div class="user-name">{{dealInfo.step_history.deal.coordinator_data.first_name}}</div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-5 pr-lg-middle">
                <div class="bordered-column-primary">
                    <div class="onwac-tab justify-content-center">
                        <div
                            class="tab-item"
                            (click)="tabs.active(item); checkTab()"
                            [ngClass]="{active: item.active}"
                            *ngFor="let item of tabs.tabItems"
                        >
                            {{item.value}}
                        </div>
                    </div>
                    <div class="scrollable h-100">

                        <!-- FORM INFO -->
                        <ng-container *ngIf="tabs.currentTabItem.id === 0">
                            <h4>{{ 'FUNNEL.dealPage.companyInfo' | translate }}</h4>
                            <div
                                *ngFor="let section of dealResponses"
                                class="form-sections"
                            >
                                <div class="info-title">{{section.title}}</div>
                                <ng-container *ngFor="let response of section.questions">
                                    <div
                                        *ngIf="response.answer"
                                        class="response"
                                    >
                                        <span class="question">{{response.question}}</span>
                                        <div *ngIf="!validUrl(response.answer); else elseBlock">
                                            <span class="answer">
                                                {{response.answer}}
                                            </span>
                                        </div>
                                        <ng-template #elseBlock>
                                            <a
                                                class="answer"
                                                [href]="response.answer"
                                                target="_blank"
                                            >{{response.answer}}</a>
                                        </ng-template>
                                    </div>
                                </ng-container>
                            </div>
                            <div *ngIf="!dealResponses">
                                <p class="small">{{ 'FUNNEL.dealPage.noRelatedForm' | translate }}</p>
                            </div>
                        </ng-container>

                        <!-- NOTES -->
                        <ng-container *ngIf="tabs.currentTabItem.id === 1">
                            <div class="notes-header d-flex justify-content-between align-items-center">
                                <h4 class="mb-0">{{notes.length}} {{'FUNNEL.dealPage.notes' | translate}}</h4>
                                <div class="d-flex align-items-center">
                                    <onwac-button
                                        *ngIf="CAN_CREATE_NOTES"
                                        [text]="'FUNNEL.dealPage.addNote' | translate"
                                        [type]="'icon'"
                                        [icon]="'add_circle'"
                                        (click)="showNewNotePopUp()"
                                    ></onwac-button>
                                </div>
                            </div>
                            <app-note
                                *ngFor="let note of notes"
                                [note]="note"
                                (onDelete)="loadDeal()"
                            ></app-note>
                        </ng-container>

                        <!-- DOCUMENTS -->
                        <ng-container *ngIf="tabs.currentTabItem.id === 2">
                            <div class="notes-header d-flex justify-content-between align-items-center">
                                <h4 class="mb-0">{{dealInfo.documentation.length}} {{ 'FUNNEL.dealPage.documents' |
                                    translate }}</h4>
                                <div class="d-flex align-items-center">
                                    <onwac-dropdown
                                        class="notes-filter"
                                        [menu]="false"
                                        *ngIf="documentsFilterItems.length > 0"
                                        [list]="documentsFilterItems"
                                        [show]="show"
                                        (onChange)="manageDocumentFilter($event)"
                                    ></onwac-dropdown>
                                    <onwac-button
                                        [text]="'FUNNEL.dealPage.addNote' | translate"
                                        [type]="'icon'"
                                        [icon]="'add_circle'"
                                        (click)="showDocumentsPopUp()"
                                    ></onwac-button>
                                </div>
                            </div>
                            <div *ngFor="let category of documentCategories">
                                <p class="category-name">{{category.name}} ({{category.documents.length}})</p>
                                <app-document
                                    [document]="document"
                                    [categories]="documentCategoryNames"
                                    [dealId]="dealId"
                                    (onDelete)="loadDeal()"
                                    *ngFor="let document of category.documents"
                                ></app-document>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-5 pl-lg-middle">
                <div class="bordered-column-base">
                    <h4>{{ 'FUNNEL.dealPage.process' | translate }}</h4>
                    <div id="processes" class="scrollable">
                        <mat-accordion >
                            <mat-expansion-panel *ngFor="let process of processesByPipeline; let i = index;" [expanded]="i === 0"
                            (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                    {{ 'FUNNEL.dealPage.timeline' | translate }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <ng-container *ngIf="process.processes">
                                    <app-process *ngFor="let process of process.processes" [process]="process"></app-process>
                                </ng-container>
                                <ng-container *ngIf="triggers">
                                    <app-trigger-card *ngFor="let trigger of triggers" [trigger]="trigger" (onSave)="onTriggerCompleted($event)"></app-trigger-card>
                                </ng-container>

                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Notes modal -->
<onwac-modal
    *ngIf="CAN_CREATE_NOTES"
    [title]="addNotePopup.title"
    [show]="addNotePopup.isVisible"
    (callback)="addNotePopup.close()"
>
    <div slot="content">
        <div class="form-group">
            <onwac-input
                [type]="'text'"
                [label]="'FUNNEL.dealCardNote.title' | translate"
                [input_name]="'dealNoteTitle'"
                [submitted]="submitted"
                [parentForm]="noteForm"
                [required]="false"
                [validators_feedback]="[
                    {name: 'required', value: 'FUNNEL.dealCardNote.requiredText' | translate}
                ]"
            ></onwac-input>
        </div>
        <div class="form-group">
            <onwac-input
                [type]="'textarea'"
                [label]="'FUNNEL.dealCardNote.textareaLabel' | translate"
                [input_name]="'dealNote'"
                [submitted]="submitted"
                [parentForm]="noteForm"
                [required]="true"
                [validators_feedback]="[
                    {name: 'required', value: 'FUNNEL.dealCardNote.requiredText' | translate}
                ]"
            ></onwac-input>
        </div>

        <div class="d-flex align-items-center mt-sm">
            <onwac-switch
                *ngIf="CAN_CREATE_NOTES_AS_PRIVATE"
                [active]="publicNote"
                (click)="publicNote = !publicNote"
            ></onwac-switch>
            <p class="small mb-0 ml-xs color-base-50"><strong>{{publicNote ? ('FUNNEL.dealCardNote.public' | translate)
                    : 'FUNNEL.dealCardNote.private' | translate}}</strong></p>
        </div>
    </div>
    <div
        slot="footer"
        class="button-row full-width"
    >
        <onwac-button
            (click)="addNotePopup.close()"
            [text]="'MODAL_NOTE.create.decline' | translate"
            [type]="'text'"
            [extra_clases]="'block'"
        ></onwac-button>
        <onwac-button
            (click)="createNewNote()"
            [text]="'MODAL_NOTE.create.accept' | translate"
            [extra_clases]="'block'"
        ></onwac-button>
    </div>
</onwac-modal>

<!-- Documents modal -->
<app-multiupload-files
    *ngIf="documentCategoryNames.length > 0"
    [toggler]="multiuploadToggler"
    [categories]="documentCategoryNames"
    [privacity]="true"
    (callback)="uploadDocuments($event)"
></app-multiupload-files>